import { ENTRY_POINT_SORT_KEYS, ENTRY_POINT_TYPES } from "@seagames/contracts";
import { z } from "zod";
import { listSearch } from "../../lib/list-page/list-search";

/**
 * The entry points list's URL state (page, filters, sort), shared by Game
 * Settings → Entry points and the A&D "Entry points" tab (M9b §3.4): both
 * routes render the same list, so they parse the same params.
 */
export const entryPointsSearch = listSearch(ENTRY_POINT_SORT_KEYS, { type: z.enum(ENTRY_POINT_TYPES), is_active: z.enum(["true", "false"]) });
export type EntryPointsSearch = z.output<typeof entryPointsSearch>;
